import { Layout, Header, SectionTitle } from "../../../../src/components";
import data from "../../../../src/pages/wt/guidelines/elevation/data.json";
import * as React from 'react';
export default {
  Layout,
  Header,
  SectionTitle,
  data,
  React
};